module.exports = __webpack_public_path__ + "media/application/images/ui/icon-link-c70f5bfab49695a4ba9741641ae81e41.png";